import { Card } from "@components/cards/card";
import { IRaffleDefaultRewardDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { useEffect, useState } from "react";
import { RaffleDefaultNumberRewardInfo } from "./rewardInfo";
import Skeleton from "react-loading-skeleton";

interface IProps {
  rewards: IRaffleDefaultRewardDTO[];
}

export function RaffleDefaultNumberRewardList({ rewards }: IProps) {
  const [reward, setReward] = useState<IRaffleDefaultRewardDTO | undefined>(
    undefined
  );
  const [visible, setVisible] = useState<boolean>(false);
  const setVisibility = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    setReward(rewards[0]);
  }, [rewards]);

  return (
    <>
      <Card>
        <div
          className="card-header py-2 d-flex flex-column justify-content-center align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setVisibility();
          }}
        >
          <div className="card-title">Premiação</div>
          <div className="card-category fw-bold">
            Clique para ver {visible ? `menos` : `mais`}
          </div>
        </div>
        <div className={`card-body pt-0 ${visible ? `` : `d-none`}`}>
          {rewards.length > 0 ? (
            <>
              <nav className="navbar navbar-expand-lg">
                <div className="container-fluid">
                  <div
                    className="navbar-collapse"
                    id="navBarRaffleDefaultNumber"
                  >
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex justify-content-center w-100">
                      {rewards.map((item, i) => (
                        <li
                          key={`${item?.order}-${item?.name}-${i}`}
                          className="nav-item d-flex justify-content-center align-items-center"
                          style={{ flex: 1 }}
                        >
                          <button
                            className={`nav-link ${
                              i === 0 ? `active` : ``
                            } w-100`}
                            onClick={() => setReward(item)}
                          >
                            <span className="fw-bold">{item?.name}</span>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </nav>
              {reward ? (
                <RaffleDefaultNumberRewardInfo reward={reward} />
              ) : (
                <div className="text-center">
                  <span>Selecione um prêmio.</span>
                </div>
              )}
            </>
          ) : (
            <Skeleton
              className={`mt-2`}
              count={1}
              height={25}
              borderRadius={5}
            />
          )}
        </div>
      </Card>
    </>
  );
}
